import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './RadishPage.css';
import radishwhitestar from '../images/radish-white-star-img.png';
import radishLogo from "../images/radish-logo.png"

const varieties = [
  {
    name: 'DS-WHITE STAR',
    image: radishwhitestar,
    description: [
      'Suitable for sole crop or intercropping with green leaves',
      'Variety with long white root and abundant green foliage',
      'Plant height: 30-35 cm',
      'Root type: Long white root',
      'Root colour: White',
      'Seed colour: Tan to dark brown',
      'Maturity: 35-45 days',
      'Seed rate: 4-5 kg per acre',
      'Germination: 5-10 days',
      'Harvesting: Around 45 days after sowing',
      'Spacing: Row to row 45 cm and plant to plant 7.5 cm',
      'Recommended season: December to February',
    ],
  },
];

export default function RadishPage() {
  return <ProductPatternPage title="Radish" varieties={varieties} pageClass="radish-page" heroImage={radishLogo} />;
}
